import React from 'react';
import { Center, Loader } from '@mantine/core';

import { useMobile, useTableauToken} from '@/hooks';

type ReportContentProps = {
  desktopUrl: string;
  mobileUrl: string;
};

const ReportContent: React.FC<ReportContentProps> = ({ desktopUrl, mobileUrl }) => {
  const { token, uuid, loading } = useTableauToken();

  const isMobile = useMobile();

  const url = isMobile ? mobileUrl : desktopUrl;

  if (loading) {
    return (
      <Center h="30dvh">
        <Loader type="dots" />
      </Center>
    );
  }

  if (!token || !uuid) {
    return null;
  }


  return (
    <tableau-viz id="tableau-viz" src={url} hide-tabs toolbar="hidden" token={token}>
      <viz-filter field="User UUID" value={uuid} />
    </tableau-viz>
  );
};

export default ReportContent;
